
import Discord from "../../../assets/duotone/Discord.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DiscordIcon({ className, dataTestid = "DiscordIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Discord data-testid={dataTestid} className={classes} {...rest} />
  );
}
